/*
 * Wraps the product page's Description block in the same collapsible
 * accordion markup the theme's native "collapsible_tab" blocks use
 * (Shipping, Returns, etc.), so Description matches those rows visually.
 * Purely additive: does not touch section markup, only enhances it client-side.
 */
(function () {
  function buildDescriptionAccordion(descEl) {
    if (!descEl || descEl.closest('details')) return;

    var container = document.createElement('div');
    container.className = 'product__accordion accordion quick-add-hidden';

    var details = document.createElement('details');
    details.id = 'Details-description-custom';
    // Join the same exclusive accordion group as the native collapsible_tab
    // rows (Shipping, Returns, ...) -- see groupPdpAccordion() below.
    details.setAttribute('name', 'pdp-accordion');

    var summary = document.createElement('summary');

    var titleWrap = document.createElement('div');
    titleWrap.className = 'summary__title';

    var heading = document.createElement('h2');
    heading.className = 'h4 accordion__title inline-richtext';
    heading.textContent = 'Description';
    titleWrap.appendChild(heading);
    summary.appendChild(titleWrap);

    // Reuse the caret icon markup from an existing native accordion row
    // (e.g. Shipping/Returns tabs) so this row matches them exactly.
    // The caret is a direct child <svg> of <summary> (a sibling of
    // .summary__title, appended last) -- not any svg nested inside the
    // title (those are heading icons with different sizing).
    var referenceSummary = document.querySelector('.product__accordion.accordion summary');
    if (referenceSummary) {
      var directSvgs = Array.prototype.filter.call(
        referenceSummary.children,
        function (c) { return c.tagName && c.tagName.toLowerCase() === 'svg'; }
      );
      var caret = directSvgs[directSvgs.length - 1];
      if (caret) {
        summary.appendChild(caret.cloneNode(true));
      }
    }

    var content = document.createElement('div');
    content.className = 'accordion__content rte';
    content.innerHTML = descEl.innerHTML;

    details.appendChild(summary);
    details.appendChild(content);
    container.appendChild(details);

    descEl.replaceWith(container);
  }

  /*
   * Product-page exclusive accordion: Description (built above) and the
   * theme's native "collapsible_tab" rows (Shipping, Returns, and any other
   * Collapsible row block editors add) all join one group, name="pdp-accordion",
   * so opening one closes the others -- matching brennware.com's product page.
   *
   * Scoped to <product-info> so this never touches the separate "Complementary
   * products" collapsible row, which is a different kind of content and stays
   * independent.
   */
  function groupNativeCollapsibleTabs() {
    document
      .querySelectorAll('product-info div.product__accordion.accordion > details[id^="Details-"]')
      .forEach(function (details) {
        if (!details.hasAttribute('name')) details.setAttribute('name', 'pdp-accordion');
      });
  }

  function init() {
    document.querySelectorAll('.product__description').forEach(buildDescriptionAccordion);
    groupNativeCollapsibleTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * Exclusive accordion fallback: native <details name="..."> already makes
 * same-named <details> mutually exclusive in modern Chrome/Edge/Safari/Firefox.
 * This listener guarantees the same "only one open at a time" behavior on
 * older browsers too.
 */
(function () {
  var GROUP_SELECTOR = 'details[name="pdp-accordion"]';

  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches(GROUP_SELECTOR) || !e.target.open) return;
    document.querySelectorAll(GROUP_SELECTOR + '[open]').forEach(function (row) {
      if (row !== e.target) row.removeAttribute('open');
    });
  }, true);
})();
